import { ApolloClient, InMemoryCache } from "@apollo/client"
import { CustomWindow } from "../custom"

declare let window: CustomWindow

export const SALEOR_API_URL = window.env.REACT_APP_SALEOR_API_URL

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  uri: SALEOR_API_URL,
})
